import { walletErrorKind } from '../../../../queries/pxtraCard/walletError';

type Options = {
  /** Replaces the generic „lädt nicht“ title; a missing account keeps its own. */
  titleKey?: string;
  /** Whether a 404 means the account is not open yet; false where the 404 says nothing about it. */
  notFoundMeansNoAccount?: boolean;
};

/**
 * The translation keys for a failed wallet query, by what the failure says, and whether
 * trying again can help: a rejected request stays rejected.
 */
export const walletErrorCopy = (error: unknown, options: Options = {}) => {
  const { titleKey = 'pxtraCard:walletLoadFailedTitle', notFoundMeansNoAccount = true } = options;
  const kind = walletErrorKind(error);

  if (kind === 'account_missing' && notFoundMeansNoAccount) {
    return {
      titleKey: 'pxtraCard:walletAccountMissingTitle',
      textKey: 'pxtraCard:walletAccountMissingText',
      retryable: true
    };
  }

  return {
    titleKey,
    retryable: kind === 'unavailable',
    textKey:
      kind === 'unavailable'
        ? 'pxtraCard:walletLoadFailedText'
        : 'pxtraCard:walletLoadFailedRejectedText'
  };
};
